module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/soluzioni_personalizzate_pagina-1a996943f9be249db2115808fe39a5e4.png";